<template>
  <span
    v-if="this.$props.status.trim() !== 'NONE'"
    :class="ordersStatus.css"
    v-t="`Orders.${ _correctState }`"
  />
</template>

<script>
export default {
  name: 'OrdersStatus',
  props: {
    status: String,
    state: String
  },
  computed: {
    ordersStatus () {
      const status = {
        CANCELED: { css: 'local-lm-validation-red' },
        AWAITS_CONFIRMATION: { css: 'local-lm-validation-orange' },
        TO_REJECT: { css: 'local-lm-validation-red' },
        IN_PREPARATION: { css: 'local-lm-validation-blue-sea' },
        AWAITS_DISPATCH: { css: 'local-lm-validation-lightness-green' },
        ON_EXPEDITION: { css: 'local-lm-validation-half-green' },
        DELIVERED: { css: 'local-lm-validation-green' },
        COMPLETED: { css: null },
        DEFAULT: { css: null }
      }

      // ! MOVIMENT-1287 Exception when state === CANCELED and status === AWAITS_CONFIRMATION the state becames first
      return status[ this._correctState ] || status['DEFAULT']
    },
    _correctState () {
      return (this.$props.status === 'AWAITS_CONFIRMATION' && this.$props.state.toUpperCase() === 'CANCELED') ? 'CANCELED' : this.$props.status
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/OrdersStatus.vue